// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"ee864ece","782":"0fbd3d96","787":"69a9a7ce"}[chunkId] + ".chunk.js";
};